module.exports = __webpack_public_path__ + "media/components/assets/img/icons/rating-b121da576eec0eb885dc4708c241008f.svg";